var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"isEmpty"},[_c('div',{staticClass:"empty-img"}),_c('span',[_vm._v(_vm._s(_vm.$t('login.dlym11')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }